import { useQuery } from '@tanstack/react-query';

import { medicalStaffApi } from '../api/medical-staff.adapter';
import type { ListMedicalStaffParams } from '../types/medical-staff.types';

export const medicalStaffQueryKeys = {
  all: ['medical-staff'] as const,
  // The list key embeds params so each filter/sort/page combo caches independently.
  list: (params: ListMedicalStaffParams) =>
    [...medicalStaffQueryKeys.all, 'list', params] as const,
  options: () => [...medicalStaffQueryKeys.all, 'options'] as const,
};

export function useMedicalStaffQuery(params: ListMedicalStaffParams) {
  return useQuery({
    queryKey: medicalStaffQueryKeys.list(params),
    queryFn: () => medicalStaffApi.listMedicalStaff(params),
  });
}

// Feature-local option pool (Departments + Job Roles). Consumed by invite/edit panels
// and the list's department filter dropdown.
export function useMedicalStaffOptionsQuery() {
  return useQuery({
    queryKey: medicalStaffQueryKeys.options(),
    queryFn: () => medicalStaffApi.listOptions(),
    // Options change infrequently; keep them warm during the session.
    staleTime: 5 * 60 * 1000,
  });
}
